import { EventEmitter } from 'utils/eventEmitter';

const loanPipelinesEventEmitter = new EventEmitter();

export default loanPipelinesEventEmitter;
